import { QueryClient } from "@tanstack/vue-query";

export const defaultQueryClientOptions = {
  queries: {
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
  },
  mutations: {
    networkMode: "always" as const,
  },
};

let client = new QueryClient({ defaultOptions: defaultQueryClientOptions });

export const queryClient: QueryClient = new Proxy({} as QueryClient, {
  get(_target, prop) {
    const value = Reflect.get(client, prop, client);
    if (typeof value === "function") {
      return (value as (...args: unknown[]) => unknown).bind(client);
    }
    return value;
  },
});

export function getQueryClient(): QueryClient {
  return client;
}

export function setQueryClientForTests(next: QueryClient): void {
  if (import.meta.env.MODE !== "test") {
    throw new Error("test only");
  }
  client = next;
}
